/* ============================================================
   KIZAMI — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Page Loader ────────────────────────────────────────────
  const loader = document.querySelector('.page-loader');
  if (loader) {
    window.addEventListener('load', () => {
      setTimeout(() => loader.classList.add('done'), 600);
    });
  }

  // ── Header scroll ──────────────────────────────────────────
  const header = document.querySelector('.site-header-wrapper');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── Mobile Nav ─────────────────────────────────────────────
  const toggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const navClose = document.querySelector('.mobile-nav-close');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    const closeNav = () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    };

    if (navClose) navClose.addEventListener('click', closeNav);

    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', closeNav);
    });
  }

  // ── Scroll Animations ──────────────────────────────────────
  const animEls = document.querySelectorAll('[data-animate]');
  if (animEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    animEls.forEach(el => io.observe(el));
  }

  // ── Product Gallery Thumbs ─────────────────────────────────
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');

  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.querySelector('img')?.src;
        if (src) {
          mainImg.style.opacity = '0';
          setTimeout(() => {
            mainImg.src = src;
            mainImg.style.opacity = '1';
          }, 200);
        }
      });
    });
    mainImg.style.transition = 'opacity 0.3s ease';
  }

  // ── ATC Button ─────────────────────────────────────────────
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-atc]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    const span = btn.querySelector('span') || btn;
    const originalText = span.textContent;
    btn.disabled = true;
    span.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        span.textContent = 'Ajouté ✓';
        await updateCartCount();
        showCartNotification();
        setTimeout(() => {
          span.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      } else {
        span.textContent = originalText;
        btn.disabled = false;
      }
    } catch (err) {
      span.textContent = originalText;
      btn.disabled = false;
    }
  });

  // ── Cart Count Update ──────────────────────────────────────
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        // Animation pulse sur le badge
        countEl.classList.remove('cart-count--pulse');
        void countEl.offsetWidth;
        countEl.classList.add('cart-count--pulse');
      }
      return cart;
    } catch (err) {
      console.error('Cart update error:', err);
    }
  }

  // ── Notification panier ─────────────────────────────────────
  function showCartNotification() {
    let notif = document.querySelector('.cart-notif');
    if (!notif) {
      notif = document.createElement('div');
      notif.className = 'cart-notif';
      notif.innerHTML = `
        <div class="cart-notif__inner">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 6L9 17l-5-5"/>
          </svg>
          <span>Article ajouté au panier</span>
          <a href="/cart" class="cart-notif__link">Voir le panier →</a>
        </div>`;
      document.body.appendChild(notif);
    }
    notif.classList.remove('cart-notif--out');
    notif.classList.add('cart-notif--in');
    clearTimeout(notif._timer);
    notif._timer = setTimeout(() => {
      notif.classList.remove('cart-notif--in');
      notif.classList.add('cart-notif--out');
    }, 3000);
  }

  updateCartCount();

  // ── Newsletter Form ────────────────────────────────────────
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = newsletterForm.querySelector('input[type="email"]')?.value;
      if (!email) return;

      const btn = newsletterForm.querySelector('button');
      btn.textContent = 'Merci !';
      btn.disabled = true;

      // Shopify customer creation via form (basic)
      setTimeout(() => {
        btn.textContent = 'Inscrit(e) ✓';
      }, 500);
    });
  }

  // ── Quantity Selector ──────────────────────────────────────
  document.querySelectorAll('.qty-selector').forEach(sel => {
    const minus = sel.querySelector('[data-minus]');
    const plus  = sel.querySelector('[data-plus]');
    const input = sel.querySelector('input');

    minus?.addEventListener('click', () => {
      const val = parseInt(input.value);
      if (val > 1) input.value = val - 1;
    });

    plus?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });

  // ── Marquee pause on hover ─────────────────────────────────
  const marquee = document.querySelector('.marquee-track');
  if (marquee) {
    marquee.addEventListener('mouseenter', () => {
      marquee.style.animationPlayState = 'paused';
    });
    marquee.addEventListener('mouseleave', () => {
      marquee.style.animationPlayState = 'running';
    });
  }

  // ── Smooth anchor scroll ───────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = document.querySelector('.site-header')?.offsetHeight || 0;
        window.scrollTo({
          top: target.offsetTop - offset - 20,
          behavior: 'smooth'
        });
      }
    });
  });

  // ── Collection filter ──────────────────────────────────────
  const filterBtns = document.querySelectorAll('.filter-btn');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      // Shopify collection filtering via URL params
      const filter = btn.dataset.filter;
      if (filter && filter !== 'all') {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', filter);
        // window.location.href = url.toString(); // uncomment in prod
      }
    });
  });

});
